import React from 'react';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useNearbyPartners from '../../people-people/Recommended/useNearbyPartners';
import Redirect from '../../../components/Redirect';

export default function Layout(props) {
  const users = useNearbyPartners();

  if (users.state === PayloadStates.FETCHING) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Educator Value</title>
        </Helmet>
        <Loader />
      </ParentLayout>
    );
  }

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Educator Value</title>
      </Helmet>
      {users.meta.totalCount >= 12 ? (
        <Redirect
          to={Urls.EDUCATOR_VALUE_YES}
          replace={true}
        />
      ) : (
        <Redirect
          to={Urls.EDUCATOR_VALUE_NO}
          replace={true}
        />
      )}
    </ParentLayout>
  );
};
